import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isEmployeeAuthenticated: undefined,
    employeeData: null
}

const employeeAuth = createSlice({
    name: "employee",
    initialState,
    reducers: {
        employeeLogin: (state, action) => {
            state.isEmployeeAuthenticated = true,
            state.employeeData = action.payload?.data
        },
        employeeLogout: (state) => {
            state.isEmployeeAuthenticated = false,
            state.employeeData = null
        }
    }
})

export const {employeeLogin, employeeLogout} = employeeAuth.actions
export default employeeAuth.reducer